import { createContext } from 'react'
const TaksContext = createContext()
export default TaksContext
